import { GlobalComposable } from "~/classes/composable/GlobalComposable"

class MainView extends GlobalComposable<{
  state: InterfaceModeType
}> {
  override defaultState = () => ({ state: "collection" as InterfaceModeType })

  switchMainView = (view: InterfaceModeType) => {
    this.state.value.state = view
  }

  isMainViewState = (view: InterfaceModeType) => {
    return this.state.value.state === view
  }

  isInAgentView = () => {
    return this.state.value.state === "agent"
  }

  isInCollectionView = () => {
    return this.state.value.state === "collection"
  }

  isInPreviewView = () => {
    return this.state.value.state === "preview"
  }
}

const mainView = new MainView("main-view", theme.colors.pink.hex)
export default function () {
  return mainView.use()
}
